import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sgtTruncate',
})
export class TruncatePipe implements PipeTransform {
  transform(
    value: string,
    limit?: number,
    ellipsis: string = '...',
  ): string {
    if (!value || !limit) {
return value;
}

    if (value.length > limit) {
      return value.slice(0, limit) + ellipsis;
    }

    return value;
  }
}
